export const statusMap: Record<string, string> = {
  PROPOSAL_STATUS_PASSED: "PASSED",
  PROPOSAL_STATUS_REJECTED: "REJECTED",
  PROPOSAL_STATUS_VOTING_PERIOD: "VOTING",
};
